import React, { useEffect, useState } from "react"
import axios from 'axios'
import { DEFAULT_ROLES } from "../constants"

export const useRoles = () => {
    const [defaultRoles, setDefaultRoles] = useState([])
    const [allRoles, setAllRoles] = useState([])
    const [isLoadingRoles, setIsLoadingRoles] = useState(false)
    const [isRolesError, setIsRolesError] = useState(false)

    useEffect(() => {
        setIsRolesError(false)
        setIsLoadingRoles(true)
        axios.get(`${process.env.API_URL}/roles`)
            .then((response) => {
                setAllRoles(response.data)
                const defaultRolesToValidate = response.data.filter((r) => {
                    return [
                        DEFAULT_ROLES.customer_admin,
                        DEFAULT_ROLES.management_user,
                        DEFAULT_ROLES.technician,
                        DEFAULT_ROLES.viewer
                    ].includes(r.code)
                })
                if (defaultRolesToValidate.length !== 4) throw new Error('Some default role(s) is/are missing')
                setDefaultRoles(defaultRolesToValidate)
                setIsLoadingRoles(false)
            }).catch((e) => {
                setIsLoadingRoles(false)
                setAllRoles([])
                setDefaultRoles([])
                setIsRolesError(true)
            })
    }, [])

    return {
        defaultRoles,
        allRoles,
        isLoadingRoles,
        isRolesError
    }
}
